<template lang="pug">
  main
    NavBarChecklist
    Loader(v-show="isLoading")
    section.section
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h3.title Checklist Válvulas&nbsp
              a.button.is-black.is-rounded(@click="backPage")
                i.fas.fa-times
        .columns
          .column.is-2-desktop.is-3-tablet
            p Seleccione una válvula
          .column.is-2-desktop.is-2-tablet
            .field
              .control
                .select.dark
                  select(v-model="valvulaSelect")
                    option VS-01
                    option VS-02
                    option VS-03
                    option VS-04
                    option VS-05
                    option VS-06
                    option VS-07
                    option VS-08
                    option VS-09
                    option VS-10
                    option VS-11
                    option VS-12
                    option VS-13
                    option VS-14
                    option VS-15
                    option VS-16
                    option VS-17
                    option VS-18
                    option VS-19
                    option VS-20
                    option VS-21
                    option VS-22
                    option VS-23
                    option VS-24
                    option VS-25
                    option VS-26
          .column.is-2-desktop.is-2-tablet(v-show="valvulaSelect.length > 0")
            a.button.is-black(@click="saveCheckList") Guardar Registro
        .columns(v-show="valvulaSelect.length > 0")
          .column.is-full-mobile.is-8-tablet.is-half-desktop.is-half-widescreen.is-half-fullhd.column-plano
            .card
              .card-image
                br
                div(style='position:relative')
                  img#main-image(src='../../assets/ValvulaPlano4.png' width='100%' v-if="tipoPlano==='2'")
                  img#main-image(src='../../assets/ValvulaPlano3.png' width='100%' v-else)
                  a.rim-hotspot.tooltip(v-for="item in items" style='position:absolute; cursor:pointer; display:block; z-index:5; overflow:hidden;' :id="item.id" :style="[styleLeftTop(item.left, item.top), styleActive(item.estado)]" @click="selectRegion(item.id, item.estado)" @mouseover="cambiarHover(true, item.id, item.estado)" @mouseleave="cambiarHover(false, item.id, item.estado)" :data-tooltip="item.descripcion") {{ item.num }}
          .column.is-full-mobile.is-4-tablet.is-half-desktop.is-half-widescreen.is-half-fullhd.column-switch
            .card
              .card-content
                p
                  b Items de válvula {{ valvulaSelect }} &nbsp
                    a.button.is-dark.is-rounded.is-small(@click="verHistoria")
                      i.fas.fa-history
                small último Reg. 
                b {{ ultimoReg }}
                p.has-text-grey-dark(v-for="map in items" :key="map.id")
                  small {{ map.descripcion }}
                    | 
                  mySwitch(:key="map.id" :estado="map.estado")
        .columns.column-blanco
</template>


<script>
  import NavBarChecklist from '@/components/checklist_Componentes/layout/NavBarChecklist.vue'
  import Loader from '@/components/shared/Loader.vue'
  import mySwitch from '@/components/checklist_Componentes/switch.vue'
  import { mapState } from 'vuex'
  import ductosServices from '@/services/ducto'
  import moment from 'moment'

  export default {
    name: 'HomeChecklist',
    components: { NavBarChecklist, Loader, mySwitch },
    data () {
      return {
        tieneDatos: false,
        isLoading: true,
        items: [],
        items_names: [],
        valores_registro: [],
        valvulaSelect: '',
        ultimoReg: '',
        tipoPlano: '1'
      }
    },
    watch: {
      valvulaSelect () {
        console.log(this.valvulaSelect)
        switch (this.valvulaSelect) {
          case 'VS-03':
            this.tipoPlano = '1'  
            break
          case 'VS-12':
            this.tipoPlano = '1'  
            break
          case 'VS-19':
            this.tipoPlano = '1'  
            break
          case 'VS-22':
            this.tipoPlano = '1'  
            break
          default:
            this.tipoPlano = '2' 
            break
        }
        this.obtenerItems()
      }
    },
    methods: {
      iniciarComponente() {
        setTimeout(() => {
          this.isLoading = false
        }, 250)
      },
      selectRegion (item, estado) {
        console.log(item)
        this.items.forEach(element => {
          if (element.id === item) {
            if (element.estado === '0') {
              element.estado = '1'
            } else {
              element.estado = '0'
            }
          } 
        })
      },
      styleLeftTop (l, t) {
        return {
          'left': l,
          'top': t
        }
      },
      styleActive (est) {
        console.log(est)
          if (est === '1') {
            return {
              'background-color': '#057d8d',
            }
          } else {
            return {
             'background-color': '#ff2b56',
            }
          }
      },
      cambiarHover (hover, id, estado) {
        if (hover) {
          document.getElementById(id).style.backgroundColor = '#f60'
          document.getElementById(id).style.color = '#ffffff'
        } else {
          if (estado === '1') {
            document.getElementById(id).style.backgroundColor = '#00c4a7'
            document.getElementById(id).style.color = '#ffffff'
          } else {
            document.getElementById(id).style.backgroundColor = '#ff2b56'
            document.getElementById(id).style.color = '#ffffff'
          }
        }
      },
      obtenerItems () {
        this.items.length = 0
        ductosServices.getCheckList_Items(this.tipoPlano)
          .then( res => {
            console.log(res)
            this.items_names = res
            ductosServices.getCheckList_valoresUlt(this.valvulaSelect)
              .then( resVal => {
                console.log(resVal)
                if (resVal.length > 0) {
                  this.valores_registro = resVal[0]
                  this.items_names.forEach(item => {
                    let est = this.valores_registro[item.id]
                    let newObject = {
                      'id': item.id,
                      'num': item.num,
                      'descripcion': item.descripcion,
                      'marca': item.marca,
                      'modelo': item.modelo,
                      'left': item.left,
                      'top': item.top,
                      'estado': est
                    }
                    this.items.push(newObject)

                  })
                  this.ultimoReg = this.valores_registro.fechaReg
                  
                } else {
                  this.items_names.forEach(element => {
                    let newObjet = {
                      'id': element.id,
                      'num': element.num,
                      'descripcion': element.descripcion,
                      'marca': element.marca,
                      'modelo': element.modelo,
                      'left': element.left,
                      'top': element.top,
                      'estado': '0'
                    }
                    this.items.push(newObjet)
                    this.ultimoReg = 'No Existen Registros aún.'
                  })
                }
              })
          })
      },
      saveCheckList () {
        this.isLoading = true
        let idCheckList = Date.now()
        let fechaReg = moment().format('YYYY-MM-DD HH:mm:ss')

          if (this.tipoPlano === '1') {
            ductosServices.add_Checklist(idCheckList, fechaReg, this.userLogin.id, this.userLogin.usuario, this.valvulaSelect, this.items[0].estado, this.items[1].estado, this.items[2].estado, this.items[3].estado, this.items[4].estado, this.items[5].estado, this.items[6].estado, this.items[7].estado, this.items[8].estado, this.items[9].estado, this.items[10].estado, this.items[11].estado, this.items[12].estado, this.items[13].estado, this.items[14].estado, this.items[15].estado, this.items[16].estado, this.items[17].estado, this.items[18].estado, this.items[19].estado, this.items[20].estado, this.items[21].estado, this.items[22].estado, this.items[23].estado, '3', this.items[24].estado, this.items[25].estado, this.items[26].estado,)
              .then(res => {
                console.log(res)
                if (res.success) {
                  setTimeout(() => {
                    this.obtenerItems()
                    this.isLoading = false
                  }, 750)
                } else {
                  console.log(res.respuesta)
                }
              })
          } else {
            ductosServices.add_Checklist(idCheckList, fechaReg, this.userLogin.id, this.userLogin.usuario, this.valvulaSelect, this.items[0].estado, this.items[1].estado, this.items[2].estado, this.items[3].estado, this.items[4].estado, this.items[5].estado, this.items[6].estado, '3',this.items[7].estado, this.items[8].estado, this.items[9].estado, this.items[10].estado, '3',this.items[11].estado, this.items[12].estado, this.items[13].estado, this.items[14].estado, this.items[15].estado, this.items[16].estado, this.items[17].estado, this.items[18].estado, this.items[19].estado, this.items[20].estado, this.items[21].estado, this.items[22].estado, '3', '3', '3')
            .then(res => {
              console.log(res)
              if (res.success) {
                setTimeout(() => {
                  this.obtenerItems()
                  this.isLoading = false
                }, 750)
              } else {
                console.log(res.respuesta)
              }
            })
          }
      },
      verHistoria () {
        this.isLoading = true
        this.$router.push({ path: `/Checklist/Historia/${this.valvulaSelect}` } )
      },
      backPage() {
        this.$router.back()
      },
    },
    created () {
      this.iniciarComponente()
    },
    computed: {
      ...mapState(['logueado', 'userLogin'])
    },
  }
</script>

<style lang="css" scoped>
  .rim-hotspot {
    width: 3.5%;
    height: 3.5%;
    border-radius: 25px;
    color: #ffffff;
    box-shadow: 7px 7px 5px 0px rgba(50, 50, 50, 0.75);
    font-weight: bold;
    font-size: 10px;
    padding-left: 5px;
    padding-top: 2px;
  }

  .image img {
    height: 700px;
    width: 650px;
  }

  .column-blanco {
    padding-bottom: 100px;
  }

  @media (min-width:1025px) and (orientation: landscape) { 
    .column-plano {
      width: 65%;
    }

    .column-switch {
      width: 30%;
    }
  }
  
</style>


// WEBPACK FOOTER //
// src/components/checklist_Componentes/HomeChecklist.vue